export class ProductionJobShared {
  sharedId: string;
  productionJobId: string;
  downloadPassword: string;
  expires: string;
}

export class SharedExportSettingsReturnData {
  isGenerateLink?: boolean;
  isRemoveShare?: boolean;
  sharedProductionJob?: ProductionJobShared;
}